<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Thiết bị</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="
            dataPermission &&
            dataPermission?.includes('CNPS_DEVICE_ORDER_TRANSFER_ECOMMERCE_CREATE')
          "
          @click="openListDevice"
          class="font-medium f12 btn btn-outline-secondary"
        >
          Chuyển TB tới kho MC tự kích hoạt
        </button>
        <button @click="directionModal = true" class="font-medium f12 btn btn-outline-secondary">
          Hướng dẫn
        </button>
        <button
          v-if="permissionExportSim"
          @click="downloadExampleExportSim"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i> Tải file mẫu xuất Sim
        </button>
        <button
          v-if="permissionExportSim"
          @click="$refs.fileInput.click()"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Import file xuất Sim
        </button>
        <input
          type="file"
          ref="fileInput"
          @change="onFileChange"
          accept=".xlsx, .xls"
          style="display: none"
        />
        <button @click="exportExcel" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian tạo"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.categoryId"
              :options="optionType"
              placeholder="Tên thiết bị"
            ></Select2>
          </div>

          <div class="form-group">
            <Select2
              v-model="warehouseSearch.region"
              :options="optionRegion"
              placeholder="Vùng"
            ></Select2>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="warehouseSearch.level"
              :options="optionLevel"
              :settings="{ placeholder: 'Cấp kho' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="warehouseSearch.inventories"
              :options="optionInventory"
              placeholder="Tên kho"
            ></Select2>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.billNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Số phiếu"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.serial"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã serial"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.numberGear"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã thùng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.managerId"
              placeholder="Người quản lý"
              :settings="settingSearch"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.keeperId"
              :settings="settingSearch"
              placeholder="Thủ kho"
            ></Select2>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.status"
              :options="
                optionStatus.filter(
                  s => !['EXPORTED', 'LENT', 'LENT_WARRANTY', 'EXPORT_RENT'].includes(s.id)
                )
              "
              :settings="{ placeholder: 'Trạng thái' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.groupstatusDevices"
              :options="Config.groupstatusDevices"
              placeholder="Nhóm trạng thái"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusBoxme"
              :options="optionBoxme"
              placeholder="Trạng thái Boxme"
            ></Select2>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.trackingNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã đơn Boxme"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusCashback"
              :options="lsStatusCashback"
              placeholder="TB Cashback"
            ></Select2>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.types"
              :options="optionState"
              :settings="{ placeholder: 'Tình trạng' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.contractCode"
              class="form-control f12 hc-37 text-search"
              placeholder="Số HĐ/PL"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeUsage"
              :options="Config.typeUsage"
              placeholder="Mục đích sử dụng"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.provider"
              :options="optionProvider"
              placeholder="Nhà cung cấp"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng thiết bị: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataDevice"
              :fields="filterTable"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #empty>
                <div class="my-2 text-center">Không có dữ liệu</div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(categoryName)="data">
                <p>{{ data.item.categoryName }}</p>
                <p v-if="data.item?.provider">
                  <span class="text-muted">NCC: </span>{{ data.item?.provider || '' }}
                </p>
              </template>
              <template #cell(orderImport)="data">
                {{ data.item.orderImport ? data.item.orderImport.billNumber : '' }}
              </template>
              <template #cell(orderExport)="data">
                {{ data.item.orderExport ? data.item.orderExport.billNumber : '' }}
              </template>
              <template #cell(timeExport)="data">
                <span v-if="data.item.orderExport && data.item.orderExport.createdTime">
                  {{
                    data.item.orderExport.createdTime == null
                      ? ''
                      : data.item.orderExport.createdTime | formatDate('HH:mm, DD/MM/YYYY')
                  }}
                </span>
              </template>
              <template #cell(contractCode)="data">
                {{ data.item.contractCode }}
              </template>
              <template #cell(typeUsage)="data">
                {{ data.item.typeUsage | transformData(Config.typeUsage) }}
              </template>
              <template #cell(statusBoxme)="data">
                <span :class="transformColor(data.item.statusBoxme, Config.statusBoxme)">
                  {{ data.item.statusBoxme | transformData(Config.statusBoxme) }}</span
                >
                <span class="mt-1">Mã đơn: {{ data.item.trackingNumber || '' }}</span>
              </template>
              <template #cell(statusCashback)="data">
                <span v-if="data.item.statusCashback === 'NO_CASHBACK'">Không Cashback</span>
                <span v-else>Cashback</span>
              </template>
              <template #cell(keeper)="data">
                <div v-if="data.item.keeper !== null">
                  {{ data.item.keeper.name }} <br />
                  <span class="text-primary">{{ data.item.keeper.email }}</span>
                  <p>Vùng: {{ data.item?.keeper?.regionName }}</p>
                </div>
                <div v-else></div>
              </template>
              <template #cell(time)="data">
                <p>
                  <b>Tạo</b>:
                  {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <br />
                <p v-if="data.item.dateModified != 0">
                  <b>Cập nhật</b>:
                  {{ data.item.dateModified | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | transformData(optionStatus) }}
                </span>
              </template>
              <template #cell(type)="data">
                <span class="badge" :class="[data.item.type ? data.item.type : '']">
                  {{ data.item.type | transformData(optionState) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="onRowSelected(data.item)">
                    <span class="mr-2">
                      <b-icon icon="eye" aria-hidden="true" />
                    </span>
                    Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-show="
                      dataUser.userId === data.item.keeperId &&
                      data.item.status === 'AVAILABILITY' &&
                      permisstionExportSimOnly(data?.item.abbreviation) &&
                      permissionExportSim
                    "
                    type="button"
                    @click="handleExportSimOfDevice(data.item.id)"
                  >
                    <span class="mr-2">
                      <b-icon icon="download" aria-hidden="true" />
                    </span>
                    Xuất sim
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      showAction.includes(data.item?.abbreviation) &&
                      dataPermission &&
                      dataPermission?.includes('CNPS_DEVICE_ORDER_TRANSFER_ECOMMERCE_CREATE') &&
                      (data.item.status === 'AVAILABILITY' || data.item.status === 'USED')
                    "
                    @click="openTransferModal(data.item, 'total')"
                  >
                    Bán TB - MC TKH - Tổng
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      showAction.includes(data.item?.abbreviation) &&
                      dataPermission &&
                      dataPermission?.includes(
                        'CNPS_DEVICE_ORDER_TRANSFER_ECOMMERCE_EMPLOYEE_CREATE'
                      ) &&
                      (data.item.status === 'AVAILABILITY' || data.item.status === 'USED')
                    "
                    @click="openTransferModal(data.item, 'individual')"
                  >
                    Bán TB - MC TKH - cá nhân
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      showAction.includes(data.item?.abbreviation) &&
                      dataPermission &&
                      dataPermission?.includes(
                        'CNPS_DEVICE_ORDER_TRANSFER_ECOMMERCE_EMPLOYEE_CREATE'
                      ) &&
                      (data.item.status === 'AVAILABILITY' || data.item.status === 'USED')
                    "
                    @click="openTransferModal(data.item, 'simtingbox')"
                  >
                    Bán TB kèm SIM - MC TKH - cá nhân
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="fl-right mr-4"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>
    <!-- Hướng dẫn -->
    <b-modal size="lg" centered v-model="directionModal">
      <template #modal-header="{ close }">
        <h5>Hướng dẫn</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div>
        <span
          ><b>Chờ nhập</b>: TB đã được tạo phiếu nhập vào kho, nhưng phiếu nhập đang chờ quản lý kho
          duyệt</span
        >
        <br />
        <span><b>Khả dụng</b>: TB đã được nhập vào kho, sẵn sàng điều chuyển hoặc xuất kho</span
        ><br />
        <span
          ><b>Chờ chuyển</b>: TB đã được tạo phiếu điều chuyển, nhưng chưa được thủ kho của kho xuất
          xác nhận chuyển TB đi</span
        ><br />
        <span><b>Đang chuyển</b>: TB đã được xác nhận chuyển đi khỏi kho xuất</span><br />
        <span
          ><b>Tạo HĐ, chờ duyệt</b>: TB đang được gắn với với HĐ (HĐ = Mới tạo/Đã gửi/Chờ ký/Đang
          ký/Chờ GĐV duyệt/Đã ký chờ duyệt/Đã ký thiếu ảnh/Cần bổ sung/Chờ GĐV duyệt)</span
        ><br />
        <span><b>HĐ thành công</b>: TB đang được gắn HĐ (HĐ = MC đang hoạt động)</span><br />
        <span
          ><b>Thất lạc</b>: Thiết bị được thủ kho kho nhận xác nhận là không nhận được hàng trong
          quá trình điều chuyển</span
        ><br />
        <span><b>Đang bảo hành</b>: Thiết bị đang được bảo hành</span>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <!-- Modal thông báo -->
    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <!-- Modal xác nhận chuyển thiết bị -->
    <b-modal id="transfer-confirm-modal" centered v-model="transferModal">
      <template #modal-header="{ close }">
        <h5>
          {{ titleConfirm || 'Bán TB - MC TKH - Tổng' }}
        </h5>
        <b-button
          size="sm"
          variant="light"
          @click="
            close()
            removeDataPopuop()
          "
        >
          x
        </b-button>
      </template>
      <div v-if="switchApi === 'simtingbox'">
        <div style="display: flex; gap: 10px; padding: 10px">
          <div class="form-group" style="width: 100%">
            <label for="serialTingBox">Thiết bị sim đi kèm</label>
            <SearchStaffAutocomplete
              size="md"
              :list="optionTypeSim"
              v-model="dataAddSim.categoryIdSim"
              placeholder="Loại thiết bị sim"
              @input="loadListDeviceSim"
            />
          </div>
          <div class="form-group" style="width: 100%">
            <label for="serialSim">Serial Sim</label>
            <SearchStaffAutocomplete
              size="md"
              id="serialSim"
              :list="optionChonseDeviceSimAdd"
              v-model="dataAddSim.serialSim"
              :class="{ 'is-invalid': errorAdd?.serialSim }"
              :placeholder="loadingSim ? 'Loading...' : 'Tìm kiếm/Chọn sim'"
              :disabled="loadingSim || !dataAddSim.categoryIdSim"
            />
            <div class="invalid-feedback" v-if="errorAdd.serialSim">
              {{ errorAdd.serialSim }}
            </div>
          </div>
        </div>
        <b-checkbox class="ml-2" v-model="dataAddSim.collectMoney">
          <p style="font-weight: 600; font-family: 'Roboto', sans-serif; font-size: 16px">
            Sim thu tiền riêng (user cần cập nhật phiếu thu sim)
          </p>
        </b-checkbox>
      </div>
      <div v-else class="text-center">
        <p>
          Bạn có chắc chắn muốn chuyển thiết bị {{ selectedName || '' }} đến kho MC tự kích hoạt?
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="confirmTransfer" :disabled="transferLoading">
          <b-spinner small v-if="transferLoading"></b-spinner>
          Xác nhận
        </b-button>
        <b-button
          variant="light"
          @click="
            cancel()
            removeDataPopuop()
          "
        >
          Huỷ
        </b-button>
      </template>
    </b-modal>
    <ModalExportNoti ref="uploadNotif" />
    <PopupList ref="listTbActiveRef" @onLoad="fetchData" />
    <PopupResultImportFile ref="refPopupResultImportFile" />
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import { CommonService } from '@/services/common.service'
  import ModalExportNoti from '@/components/ModalExportNoti.vue'
  import PopupList from './components/popupList.vue'
  import { showMess } from '@/config/utils'
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'
  import PopupResultImportFile from './components/PopupResultImportFile.vue'

  const showAction = [
    'TingBox01',
    'TingBox02',
    'TingBoxS',
    'SIMVIETTEL',
    'SIMMOBI',
    'SIMSKY',
    'SP07',
    'TingBoxPRO',
    'TingBoxS2',
    'TingBoxS3',
    'TingBoxP1',
  ]

  const fieldsTable = [
    // { key: 'selected' },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'categoryName', label: 'Model/NCC' },
    { key: 'serial', label: 'Mã serial' },
    { key: 'numberGear', label: 'Mã thùng' },
    { key: 'inventoryName', label: 'Tên kho' },
    { key: 'orderImport', label: 'Phiếu nhập đầu' },
    { key: 'orderExport', label: 'Phiếu xuất cuối' },
    { key: 'timeExport', label: 'Thời gian xuất' },
    { key: 'keeper', label: 'Thủ kho' },
    { key: 'time', label: 'Thời gian' },
    { key: 'type', label: 'Tình trạng' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'statusBoxme', label: 'Trạng thái Boxme' },
    // { key: 'trackingNumber', label: 'Mã đơn Boxme' },
    { key: 'statusCashback', label: 'TB Cashback' },
    { key: 'contractCode', label: 'Số HĐ/PL' },
    { key: 'typeUsage', label: 'Mục đích sử dụng' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
    // { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
  ]

  export default {
    mixins: [prepareQueryParamsMixin],
    components: { ModalExportNoti, PopupList, SearchStaffAutocomplete, PopupResultImportFile },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        categoryAllowClearSim: 'common/categoryAllowClearSim',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataDevice ? this.selected.length === this.dataDevice.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataDevice.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
      permissionExportSim() {
        return this.dataPermission.includes('CNPS_DEVICE_CLEAR_SIM')
      },
      permisstionExportSimOnly() {
        return value => {
          return this.categoryAllowClearSim.includes(value)
        }
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'warehouseSearch.region': function () {
        this.testing()
      },
      'warehouseSearch.level': function () {
        if (this.warehouseSearch.level.length === 0) {
          delete this.warehouseSearch.level
        }
        this.testing()
      },
    },
    data() {
      return {
        importResultData: null,
        showAction,
        Config,
        loading: false,
        showLoading: false,
        fieldsTable,
        filterTable: fieldsTable,
        optionType: [],
        optionProvider: [
          { id: '0', text: 'Tất cả' },
          { id: 'VIMO', text: 'Vi Mô' },
          { id: 'NGAN_LUONG', text: 'Ngân Lượng' },
        ],
        optionLevel: Config.levelWarehouse,
        optionStatus: Config.statusDevices,
        lsStatusCashback: [{ id: '0', text: 'Tất cả' }, ...Config.statusCashback],
        optionState: Config.stateDevices,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionStaff: [],
        optionRegion: [],
        optionInventory: [],
        copy: [],
        warehouseSearch: {},
        dataDevice: [],
        search: {
          limit: 50,
          page: 1,
        },
        searchKeyword: '',
        pagination: {
          total: 0,
        },
        errorAdd: {
          serialTingBox: '',
          serialSim: '',
        },
        titleConfirm: '',
        switchApi: 'total',
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        selected: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        directionModal: false,
        loadingSim: false,
        sseData: 0,
        transferModal: false,
        transferLoading: false,
        selectedDeviceId: null,
        selectedName: '',
        tLoadAccount: null,
        dataAddSim: {
          collectMoney: true,
        },
        optionBoxme: [{ id: '0', text: 'Tất cả' }, ...Config.statusBoxme],
        optionTypeSim: [],
        optionChonseDeviceSimAdd: [],
        settingSearch: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''

              // Nếu không có từ khóa tìm kiếm, trả về 20 items đầu tiên
              if (!txtSearch) {
                const defaultResults = this.optionStaff.slice(0, 20)
                defaultResults.unshift({ id: '0', text: 'Tất cả' })
                return success({
                  results: defaultResults,
                })
              }

              if (this.tLoadAccount) {
                clearTimeout(this.tLoadAccount)
              }

              this.tLoadAccount = setTimeout(() => {
                try {
                  let filtered = this.optionStaff

                  // Tìm kiếm nếu có từ khóa
                  filtered = this.optionStaff.filter(staff => {
                    return staff.text.toLowerCase().includes(txtSearch.toLowerCase().trim())
                  })

                  // Giới hạn 20 kết quả
                  filtered = filtered.slice(0, 20)

                  // Thêm option "Tất cả" vào đầu danh sách
                  filtered.unshift({ id: '0', text: 'Tất cả' })

                  success({
                    results: filtered,
                  })
                } catch (error) {
                  failure(error)
                }
              }, 500)
            },
          },
        },
      }
    },
    created() {
      this.typeDeviceConfig()
      this.getListStaff()
      this.getListRegion()
      this.getListInventory()
      this.transformDate()
      this.fetchData()
      this.typeDevice()
      this.getListSim()
    },

    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      async importFileSimDevice(file) {
        try {
          this.loading = true
          const formData = new FormData()
          formData.append('file', file)
          const response = await DeviceService.importSimForDevice(formData)
          this.importResultData = response.data
          if (response.code !== 1000) {
            showMess(this, 'Thất bại', response.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.loading = false
        }
      },
      async onFileChange(event) {
        const file = event.target.files[0]
        if (!file) return
        const fileType = file.name.split('.').pop().toLowerCase()
        if (fileType !== 'xlsx' && fileType !== 'xls') {
          showMess(
            this,
            'Error',
            'Vui lòng chọn file Excel (.xlsx, .xls)',
            'danger',
            'b-toaster-top-right',
            3000
          )
          this.$refs.fileInput.value = ''
          return
        }
        await this.importFileSimDevice(file)

        if (this.importResultData) {
          this.$refs.refPopupResultImportFile.openModal(this.importResultData)
        }
        this.$refs.fileInput.value = ''
      },
      async downloadExampleExportSim() {
        try {
          this.showLoading = true
          await DeviceService.exportExampleSimDevice()
        } catch (error) {
          showMess(
            this,
            'Thất bại',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.showLoading = false
        }
      },
      async handleExportSimOfDevice(id) {
        const params = {
          id,
        }
        try {
          this.showLoading = true
          const response = await DeviceService.exportSimForDeviceById(params)
          if (response.code === 1000) {
            showMess(
              this,
              'Thành công',
              'Xuất sim thành công',
              'success',
              'b-toaster-top-right',
              3000
            )
          } else {
            showMess(this, 'Thất bại', response.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (error) {
          showMess(
            this,
            'Thất bại',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.showLoading = false
        }
      },
      transformColor(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].bgColor
      },
      removeDataPopuop() {
        this.optionChonseDeviceSimAdd = []
        this.errorAdd = {}
        this.dataAddSim = {}
      },
      // AI
      // async loadListDeviceSim(id) {
      //   // AI
      //   try {
      //     // AI
      //     this.loadingSim = true // AI
      //     const simParams = {
      //       inventoryIds:[this.dataAddSim?.inventoryId || ''],// AI
      //       // AI
      //       categoryId: id, // Use categoryIdSim as categoryId for this call    // AI
      //       page: 1, // AI
      //       limit: 1, // Minimal limit to just get count    // AI
      //       sortResultList: [
      //         {
      //           // AI
      //           field: 'serial', // AI
      //           direction: 'DESC' // AI
      //         } // AI
      //       ]
      //     } // AI
      //     // First API call with minimal parameters to get total count
      //     const initialResponse = await DeviceService.listDevice(simParams)

      //     if (initialResponse.code === 1000 && initialResponse.data) {
      //       const totalCount = initialResponse.data.count || 0

      //       if (totalCount > 0) {
      //         // Second API call with limit set to total count to get all devices
      //         const fullResponse = await DeviceService.listDevice({
      //           ...simParams,
      //           limit: totalCount
      //         })

      //         if (fullResponse.code === 1000 && fullResponse.data) {
      //           this.optionChonseDeviceSimAdd =
      //             fullResponse.data.devices.map((e) => ({
      //               id: e.id,
      //               text: e.serial
      //             })) || []
      //         }
      //       } else {
      //         this.optionChonseDeviceSimAdd = []
      //       }
      //     }
      //   } catch (error) {
      //     console.error('Error loading sim device list:', error)
      //   } finally {
      //     this.loadingSim = false
      //   }
      // },

      loadListDeviceSim(id) {
        this.loadingSim = true
        this.optionChonseDeviceSimAdd =
          this.optionChonseDeviceSimAdd.filter(e => e.categoryId !== id) || []
        this.loadingSim = false
      },
      async getListSim() {
        // AI
        try {
          // AI
          const data = await DeviceService.getListSimByEmployee({}) // AI
          if (data.success) {
            // AI
            // Lọc các thiết bị có categoryName chứa "SIM"  // AI
            const simDevices = data.data.filter(device => {
              // AI
              return (
                // AI
                device.categoryName && // AI
                device.categoryName.toUpperCase().includes('SIM') // AI
              ) // AI
            }) // AI

            this.optionChonseDeviceSimAdd = simDevices.map(device => {
              // AI
              return {
                // AI
                id: device.id, // AI
                text: device.serial, // AI
              } // AI
            }) // AI
            return simDevices // AI
          } // AI
        } catch (error) {
          // AI
          console.log(error) // AI
        } // AI
      }, // AI
      async typeDevice() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            // Lọc các thiết bị có nickname bắt đầu bằng "SIM"
            const filteredSimData = data.data.filter(
              e => e.nickname && e.nickname.startsWith('SIM')
            )
            // Sắp xếp theo nickname
            filteredSimData.sort((a, b) => a.nickname.localeCompare(b.nickname))

            this.optionTypeSim = filteredSimData.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            }) // AI
          }
        } catch (error) {
          console.log(error)
        }
      },
      openListDevice() {
        this.$refs.listTbActiveRef.show(this.optionType || [])
      },
      openTransferModal(item, type) {
        this.switchApi = type
        this.titleConfirm =
          type === 'total'
            ? 'Bán TB - MC TKH - Tổng'
            : type === 'simtingbox'
              ? 'Bán TB kèm SIM - MC TKH - cá nhân'
              : 'Bán TB - MC TKH - Cá nhân'
        this.selectedName = item.categoryName
        this.selectedDeviceId = item.id
        this.transferModal = true
        this.dataAddSim = item
        this.dataAddSim.collectMoney = true
      },
      async confirmTransfer() {
        this.transferLoading = true
        try {
          if (this.switchApi === 'total') {
            const response = await DeviceService.ComfirmECommerce({
              deviceIds: [this.selectedDeviceId] || [],
              note: '',
            })
            if (response.success) {
              showMess(
                this,
                'Success',
                response.message || 'Thành công chuyển TB',
                'success',
                'b-toaster-top-right',
                5 * 60 * 60
              )
              this.transferModal = false
              this.fetchData() // Refresh the device list
            } else {
              showMess(
                this,
                'Error',
                response.message || 'Lỗi xác nhận chuyển TB',
                'danger',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            }
          } else if (this.switchApi === 'simtingbox') {
            // Validate form
            let isValid = true
            if (!this.dataAddSim.serialSim) {
              this.errorAdd.serialSim = 'Vui lòng chọn Serial Sim'
              isValid = false
            }

            if (!isValid) {
              return
            }

            const response = await DeviceService.ComfirmEmployeECommerceSim({
              idTingBox: this.dataAddSim.id,
              idSim: this.dataAddSim.serialSim,
              collectMoney: this.dataAddSim.collectMoney,
            })

            if (response.code === 1000) {
              showMess(
                this,
                'Success',
                response.message || 'Thành bán công TB kèm SIM - MC tự kích hoạt',
                'success',
                'b-toaster-top-right',
                5 * 60 * 60
              )
              this.transferModal = false
              this.fetchData() // Refresh the device list
            } else {
              showMess(
                this,
                'Error',
                response.message || 'Lỗi xác nhận bán TB',
                'danger',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            }
          } else {
            const response = await DeviceService.ComfirmEmployeECommerce({
              deviceIds: [this.selectedDeviceId] || [],
              note: '',
            })
            if (response.success) {
              showMess(
                this,
                'Success',
                response.message || 'Thành bán TB - MC tự kích hoạt',
                'success',
                'b-toaster-top-right',
                5 * 60 * 60
              )
              this.transferModal = false
              this.fetchData() // Refresh the device list
            } else {
              showMess(
                this,
                'Error',
                response.message || 'Lỗi xác nhận bán TB',
                'danger',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            }
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Lỗi xác nhận chuyển TB',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.transferLoading = false
        }
      },
      async testing() {
        try {
          this.showLoading = true
          this.optionInventory = this.copy
          if (this.checkSelect(this.warehouseSearch.region)) {
            await this.listStaffRegion([this.warehouseSearch.region])
            this.optionInventory = this.optionInventory.filter(
              el => el.regions !== null && el.regions.includes(this.warehouseSearch.region)
            )
          } else {
            delete this.warehouseSearch.region
          }
          if (this.checkSelect(this.warehouseSearch.level)) {
            this.optionInventory = this.optionInventory.filter(
              el => el.level !== null && this.warehouseSearch.level.includes(el.level)
            )
          } else {
            delete this.warehouseSearch.level
          }
        } catch (error) {
        } finally {
          this.showLoading = false
        }
      },
      onRowSelected(item) {
        window.open(`/device/${item.id}`, '_blank')
      },
      transformDate() {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      async typeDeviceConfig() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            this.optionType = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionType.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListStaff() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.success) {
            this.optionStaff = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.userName} - ${e.name}`,
              }
            })
            // this.optionStaff.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async listStaffRegion(regionList) {
        try {
          const data = await StaffService.getListLowerGrade({
            userId: this.dataUser.userId,
            region: regionList,
          })
          this.optionStaff = data.data.map(e => {
            return { id: e.id, text: `${e.name} - ${e.userName}` }
          })
        } catch (e) {
          console.error(e)
        }
      },
      async getListRegion() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionRegion.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListInventory() {
        try {
          const data = await DeviceService.infoWarehouse()
          if (data.success) {
            const body = data.data.map(e => {
              return {
                ...e,
                text: e.name,
              }
            })
            body.unshift({ id: '0', text: 'Tất cả', regions: [], level: '' })
            this.optionInventory = [...body]
            this.copy = [...body]
          }
        } catch (error) {
          console.log(error)
        }
      },

      checkSelect(sel) {
        if (sel !== '0' && sel !== undefined) {
          return true
        } else {
          return false
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.warehouseSearch = {}
        this.selected = []
        this.optionInventory = this.copy
        await this.fetchData()
      },

      async fetchData() {
        try {
          this.loading = true
          if (this.search.categoryId === '0') delete this.search.categoryId
          if (this.search.provider === '0') delete this.search.provider
          if (this.search.managerId === '0') delete this.search.managerId
          if (this.search.keeperId === '0') delete this.search.keeperId
          if (this.search.statusBoxme === '0') delete this.search.statusBoxme
          if (this.search.trackingNumber === '0') delete this.search.trackingNumber

          if (this.checkSelect(this.warehouseSearch.inventories)) {
            this.search.inventoryIds = [this.warehouseSearch.inventories]
          } else {
            if (
              this.warehouseSearch.region !== undefined ||
              this.warehouseSearch.level !== undefined
            ) {
              const idInventory = this.optionInventory.map(e => e.id)
              this.search.inventoryIds = idInventory
            } else {
              delete this.search.inventoryIds
            }
          }
          await this.listDevice()
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      prepareData() {
        if (this.search.groupstatusDevices === '0') delete this.search.groupstatusDevices
        const params = cloneDeep(this.search)
        if (params.groupstatusDevices === 'INVENTORY') {
          params.status = [
            'AVAILABILITY',
            'WAIT_TRANSFER',
            'MOVING',
            'WARRANTY',
            'WARRANTING',
            'USED',
          ]
        }
        delete params.groupstatusDevices
        return params
      },
      async listDevice() {
        const params = this.prepareData()
        const data = await DeviceService.listDevice(params)
        if (data.success) {
          this.dataDevice = data.data.devices || []
          this.pagination.total = data.data.count ? data.data.count : 0
        }
      },
      async exportExcel() {
        try {
          this.showLoading = true
          const params = this.prepareData()
          delete params.page
          delete params.limit
          const body = {
            object: params,
            type: 'CNPS_DEVICE_DEVICE',
          }
          const data = await CommonService.receiveFile(body)
          if (data.success) {
            this.openModalLoadFile(data.data.id)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }

  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }
</style>
